// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iul input {
  font-size: 2.6rem;
}

.margin {
  margin-top: 35px;
  margin-bottom: 35px;
}

.divradiominuti {
  float: left;
  padding-right: 10px;
  padding-bottom: 10px;
  padding-top: 10px;
}

.labelradiominuti {
  vertical-align: super;
  color: var(--color-primary);
}

.radiomodlezione {
  vertical-align: text-bottom;
  margin-right: 2px;
}

.labelradiomodlezione {
  color: var(--color-primary);
}

.labelore {
  font-size: x-large;
  margin-top: -10px;
  margin-bottom: 10px;
}

.labelminuti {
  font-size: large;
}

.labelnote {
  font-size: x-large;
}

.labeldataora {
  font-size: x-large;
  margin-top: -10px;
  margin-bottom: 10px;
}

.labelpresenze {
  font-size: x-large;
  margin-bottom: 10px;
}

.labelattivitareale {
  font-size: x-large;
  margin-top: -10px;
  margin-bottom: 10px;
}

.textarea {
  float: left;
  width: 77%;
  padding-left: 0px;
  margin-bottom: -60px;
}

.dataora {
  padding-top: 10px;
  width: 50%;
  width: 100%;
}

.checkbox {
  margin-left: -15px;
  width: 100%;
}

.toggle {
  margin-left: -15px;
  margin-top: -20px;
}

.footer {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-left: 15px;
  width: 95%;
}

:host form ion-item {
  --highlight-color-invalid: none;
  --highlight-color-valid: none;
}`, "",{"version":3,"sources":["webpack://./src/app/avvio-rilevazione/avvio-rilevazione.page.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,2BAAA;AACJ;;AAEA;EACI,2BAAA;EACA,iBAAA;AACJ;;AAEA;EACI,2BAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,WAAA;EACA,UAAA;EACA,iBAAA;EACA,oBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,UAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;AACJ;;AAGI;EACI,+BAAA;EACA,6BAAA;AAAR","sourcesContent":[".iul input {\n    font-size: 2.6rem;\n    }\n\n.margin {\n    margin-top: 35px;\n    margin-bottom: 35px;\n    } \n \n.divradiominuti {\n    float:left; \n    padding-right: 10px;\n    padding-bottom: 10px;\n    padding-top: 10px;\n}\n\n.labelradiominuti {\n    vertical-align: super;\n    color: var(--color-primary);\n}\n\n.radiomodlezione {\n    vertical-align: text-bottom;\n    margin-right: 2px;\n}\n\n.labelradiomodlezione {\n    color: var(--color-primary);\n}\n\n.labelore {\n    font-size: x-large;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.labelminuti {\n    font-size: large;\n}\n\n.labelnote {\n    font-size: x-large;\n}\n\n.labeldataora {\n    font-size: x-large;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.labelpresenze {\n    font-size: x-large;\n    margin-bottom: 10px;\n}\n\n.labelattivitareale {\n    font-size: x-large;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.textarea {\n    float:left; \n    width: 77%;\n    padding-left: 0px;\n    margin-bottom: -60px;\n}\n\n.dataora {\n    padding-top: 10px;\n    width: 50%;\n    width: 100%;\n}\n\n.checkbox {\n    margin-left: -15px;\n    width: 100%;\n}\n\n.toggle {\n    margin-left: -15px;\n    margin-top: -20px;\n}\n\n.footer {\n    margin-top: 20px;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 15px;\n    margin-left: 15px;\n    width: 95%;\n}\n\n:host {\n    form ion-item {\n        --highlight-color-invalid: none; // invalid underline color\n        --highlight-color-valid: none; // valid underline color\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
